var $body = $('body');
$(document).ready(function () {

    //Mobile Menu
    $('.menu-trigger').on('click', function () {
        $('body').toggleClass('menu--open');
        nav_height();
    });
    //Sub Menu    
    $('.nav-arrow').on('click', function () {
        $(this).parent().siblings('li').removeClass('sub--open').find('ul').slideUp();
        $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
    });
    // Go to top
    $(".goto-top").click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 1000);
        return false;
    });

    if (win_width() > 992) {
        // Headroom JS    
        var myElement = document.querySelector("header.page");
        var headroom = new Headroom(myElement);
        headroom.init();
    }

    $('.vertical-menu li a,.cta-menu-list li a').click(function () {
        if (win_width() > 992) {
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top
            }, 900);
        } else {
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - header_height()
            }, 900);
        }
        return false;
    });
    $('.scroll-down').bind('click', function (event) {
        if (win_width() > 992) {
            $('html, body').stop().animate({
                scrollTop: ($(this).parents('.inclusive-section').next().offset().top)
            }, 800);
        } else {
            $('html, body').stop().animate({
                scrollTop: ($(this).parents('.inclusive-section').next().offset().top - header_height())
            }, 800);
        }

        event.preventDefault();
    });
    // treaser-slider
    teaser_slider();
    $('.image-teaser-image').matchHeight({
        property: 'min-height'
    });
    $('.image-teaser-content').matchHeight({
        property: 'min-height'
    });

    //Map position
    map_pos();

    if ($('.special-banner-wrap').length) {
        $('body').addClass('special-element-page');
        if ($("body").hasClass('special-element-page')) {
            skrollr.init();
        }
    }

});
$(window).on('load', function () {
//    if ($('.special-banner-wrap').length) {
//        $('body').addClass('special-element-page');
//    }

    //Full Section Scroll Effect
    section_scroll();

});
$(window).resize(function () {
    nav_height();
    teaser_slider();
    setTimeout(function () {
        $('.image-teaser-image').matchHeight({
            property: 'min-height'
        });
        $('.image-teaser-content').matchHeight({
            property: 'min-height'
        });
    }, 250);
    //Map position
    map_pos();
});

//add and remove active class in vertical menu

var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function (e) {
    var scroll = $(window).scrollTop(), menu_position = win_height() + 70;

    if (win_width() > 992) {
        // Full Page Scroll 
        var bottom_position = $('.cta-section-wrap').position().top,
                latest_scroll = $(window).scrollTop();
        if ($('.vertical-menu').length) {
            if (scroll > menu_position) {
                $('.vertical-menu').addClass('menu-active');
            } else {
                $('.vertical-menu').removeClass('menu-active');
            }
        }
        if (latest_scroll >= bottom_position) {
            $('.vertical-menu').removeClass('menu-active');         
        }
//        $('.inclusive-section').each(function (i) {
//            if ($(this).position().top <= scroll) {
//                $('.vertical-menu li.active').removeClass('active');
//                $('.vertical-menu li').eq(i).addClass('active');
//                $('.inclusive-section.active-section').removeClass('active-section');
//                $('.inclusive-section').eq(i).addClass('active-section');
//            }
//        });
        if ($('.inclusive-section').hasClass('mPS2id-target-last')) {
            if ($('.mPS2id-target-last .inclusive-img').hasClass('down-image')) {
                setTimeout(function () {
                    $('.mPS2id-target-last').find(".animated-img").addClass("show animated");
                }, 500);
            } else if ($('.mPS2id-target-last .inclusive-img').hasClass('up-image')) {
                setTimeout(function () {
                    $('.mPS2id-target-last').find(".animated-img").addClass("show animated");
                }, 500);
            }
        }
    }
    if (scroll >= 100) {
        $('body').addClass('fixed-header');
    } else {
        $('body').removeClass('fixed-header');
    }

    /* for go to top arrow */
    var currentScroll = $(this).scrollTop();
    if (currentScroll > previousScroll) {
        if (scroll >= stickyOffset + 100) {
            $('.goto-top').addClass('visible');
        }
    } else {
        $('.goto-top').removeClass('visible');
    }
});
function nav_height() {
    if (win_width() > 992) {
        $('.navigation').css('height', 'auto');
    } else {
        $('.navigation').css('height', win_height() - header_height());
    }
}

function win_height() {
    return $(window).outerHeight();
}

function win_width() {
    return $(window).width();
}

function header_height() {
    return $('header.page').outerHeight();
}

function teaser_slider() {
    var imageSlider = $('.image-teaser-slider');
    if (win_width() < 576) {
        //client carousel        
        if (imageSlider.length) {
            if (imageSlider.find('.image-teaser-slide').length > 1) {
                imageSlider.owlCarousel({
                    stagePadding: 5,
                    dots: true,
                    lazyLoad: true,
                    loop: true,
                    items: 1,
                    margin: 9
                });
            } else {
                imageSlider.stop();
            }
        }
    } else {
        imageSlider.trigger('destroy.owl.carousel');
        imageSlider.addClass('off');
    }
}

function map_pos() {
    //Map position
    var mapheight = $('.map-wrapper').outerHeight();
    $('.map-toggle-btn').click(function () {
        $('.map-wrapper').css('height', mapheight * 2);
        $('.map-overlay').fadeOut();
    });
}

function banner_height() {
    return $('.small-banner').outerHeight();
}
function section_scroll() {
    if (win_width() > 992) {
        /* Page Scroll to id fn call */
        $("#navigation-menu a,a[href='#top'],a[rel='m_PageScroll2id']").mPageScroll2id({
            highlightSelector: "#navigation-menu a"
        });

        /* demo functions */
        $("a[rel='next']").click(function (e) {
            e.preventDefault();
            var to = $(this).parent().parent('.inclusive-section', '#content .cta-section-wrap', '#content .banner-section', '#content .content-section').next().attr("id");
            $.mPageScroll2id("scrollTo", to);
        });

        if (!$(document).data("mPS2id")) {
            console.log("Error: 'Page scroll to id' plugin not present or activated. Please run the code after plugin is loaded.");
            return;
        }

        $(document).data("mPS2idExtend", {
            selector: "._mPS2id-h",
            currentSelector: function () {
                return this.index($(".mPS2id-highlight-first").length ? $(".mPS2id-highlight-first") : $(".mPS2id-highlight"));
            },
            input: {y: null, x: null},
            i: null,
            time: null
        }).on("scrollSection", function (e, dlt, i) {
            var d = $(this).data("mPS2idExtend"),
                    sel = $(d.selector);
            if (!$("html,body").is(":animated")) {
                if (!i)
                    i = d.currentSelector.call(sel);
                if (!(i === 0 && dlt > 0) && !(i === sel.length - 1 && dlt < 0))
                    sel.eq(i - dlt).trigger("click.mPS2id");
            }
        }).on("keydown", function (e) { //keyboard
            var code = e.keyCode ? e.keyCode : e.which,
                    keys = $(this).data("mPS2id").layout === "horizontal" ? [37, 39] : [38, 40];
            if (code === keys[0] || code === keys[1]) {
                if ($($(this).data("mPS2idExtend").selector).length)
                    e.preventDefault();
                $(this).trigger("scrollSection", (code === keys[0] ? 1 : -1));
            }
        });

        //mousewheel (https://github.com/jquery/jquery/issues/2871)
        var supportsWheel = false;
        function wheel(e) {
            if (e.type == "wheel")
                supportsWheel = true;
            else if (supportsWheel)
                return;
            if ($($(document).data("mPS2idExtend").selector).length)
                e.preventDefault();
            $(document).trigger("scrollSection", ((e.detail < 0 || e.wheelDelta > 0 || e.deltaY < 0 || e.deltaX < 0) ? 1 : -1));
        }
        ;
        document.addEventListener('wheel', wheel, {passive: false}, false);
        document.addEventListener('mousewheel', wheel, {passive: false}, false);
        document.addEventListener('DOMMouseScroll', wheel, {passive: false}, false);

    }
}